import React, {PureComponent}  from 'react';
import ValidateButton from '../../TicketsWhite/ValidateButton';
import axios from 'axios';
import styled from 'styled-components';

import Styles from './UploadFileButton.styles';

const ButtonWrapper = styled.div`${Styles.buttonWrapper}`; // prettier-ignore

class UploadFileButton extends PureComponent{

     /**
     * Constructor method
     * @param {*} props - component props
     */
    constructor(props) {
        super(props);
        this.getPresignedUrl = this.getPresignedUrl.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.state = {
            fileSelected: false,
            fileText: props.translations.emptyFile
        };
    }

    getPresignedUrl = (fileName) => {
        const { props: {assistPassTempId} } = this;
        return axios.get(process.env.GATSBY_TEMP_FILES_URL, {
          params: {
            id: assistPassTempId,
            name: fileName
          }
        });
    };
    
    uploadFile = (evt) => {
        const { props: {assistPassTempId, translations} } = this;
        const files = evt.target.files;
        console.log(files[0]);
        console.log(assistPassTempId);
        this.setState(() => ({
            fileSelected: false,
            fileText: translations.loading+"..."
        }));
        Promise.all([Promise.resolve(files[0]), this.getPresignedUrl(evt.target.name)])
          .then(([fileBuffer, presignedResponse]) => {
            const presignedUrl = presignedResponse.data.signedUrl;
            return axios.put(presignedUrl, fileBuffer, {
              headers: {
                'Content-Type': fileBuffer.type
              }
            });
          })
          .then((putResponse) => {
            console.log(putResponse);
            this.setState(() => ({
                fileSelected: true,
                fileText: files[0].name
                //fileText: (files[0].name.length > 20 ? files[0].name.substring(0, 10) + "..." + files[0].name.substring(files[0].name.length - 11) : files[0].name)
            }));
        });
        
    };

     render() {
        const {
            props: { name, message, linkName, link },
            state: {fileSelected, fileText}
          } = this;
        return (
            <div style={{flex: 1, position: 'relative'}}>
                <p style={{fontSize: '16px', margin: '5px 16px', fontWeight: 'bold'}}>
                  <span style={{width: '200px', display: "inline-block"}}>{message}</span>
                  <a href={link} style={{color: 'blue'}} rel="noreferrer noopener" target="_blank">{linkName}</a>
                </p>
                <ButtonWrapper>
                <div style={{width: '200px'}}>
                  <ValidateButton
                      message={"Submit"}
                      backgroundColor="#3F2A55"
                  />
                </div>
                <input
                      name={name}
                      type="file"
                      accept=".png,.jpg,.jpeg,.pdf"
                      multiple={false}
                      message={""}
                      backgroundColor="#3F2A55"
                      style={{opacity: 0, fontSize: 0, cursor: 'pointer', position: 'absolute', top: '30%', left: '0', width: '13%', height: '50%'}}
                      onChange={this.uploadFile}
                  />
                  {<p style={{fontSize: '16px', color: fileSelected ? 'green' : 'gray', margin: '15px'}}>{fileText}</p>}
                </ButtonWrapper>
            </div>
          );
    };  
}

export default UploadFileButton;
/*
<input
                      name={name}
                      type="file"
                      accept=".png,.jpg,.jpeg,.pdf"
                      multiple={false}
                      message={""}
                      backgroundColor="#3F2A55"
                      style={{opacity: 0, fontSize: 0, cursor: 'pointer', position: 'absolute', top: '0', left: '0', width: '100%', height: '100%'}}
                      onChange={this.uploadFile}
                  />
                  */